enum Endpoints {
    GET = '/version',
}

export { Endpoints };
